<i18n>
{
  "de": {
    "login": "Anmelden",
    "or": "oder",
    "signup": "Registrieren",
    "toComment": "um selbst zu kommentieren."
  },
  "en": {
    "login": "Login",
    "or": "or",
    "signup": "Sign up",
    "toComment": "to comment."
  }
}
</i18n>

<template>
  <div>
    <span
      class="login-button"
      @click.stop="doLogin"
    >
      {{
        $t('login')
      }}
    </span>
    {{ $t('or') }}
    <span
      class="signup-button"
      @click.stop="doLogin"
    >
      {{
        $t('signup')
      }}
    </span>
    {{ $t('toComment') }}
  </div>
</template>

<script>
export default {
  name: 'ctaComment',
  methods: {
    doLogin() {
      this.$root.$emit('closeModalPost')
      this.$root.$emit('showLogin')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/sass/_variables';

.login-button,
.signup-button {
  cursor: pointer;
  color: var(--primary-color);

  &:hover {
    text-decoration: underline;
  }
}
</style>
